import { Modal } from 'antd';
import PurchaseOrderListModal from 'pages/Purchase/PurchaseOrderListModal';
import React from 'react';
import { POSelectedType } from './POSelect';

export type POSearchModalProps =  {
  visible: boolean;
  onCancel: () => void;
  setPo?: (
    PO: POSelectedType
  ) => void;
};

const POSearchModal = ({
  onCancel,
  visible,
  setPo,
}: POSearchModalProps) => {
  return (
    <Modal open={visible} onCancel={onCancel} width={1200} destroyOnClose>
      <PurchaseOrderListModal
        onSelect={setPo}
      />
    </Modal>
  );
};

export default POSearchModal;
